﻿export class FileTypeNotAllowed {
    constructor(public type: string, public allowedTypes: string[]) { }
}